<template>
    <div>
        <h3 class="font-weight-light text-center pt-2">{{ heading }}</h3>
        <strong><hr class="w-50 pt-2"></strong>
    </div>
</template>
<script>
export default {
    props: {
        heading: String
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/PageHeading.vue